import { stats } from '@/mocks/homeData';

export default function StatsBar() {
  return (
    <section className="w-full py-10 md:py-14 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-white/15 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-white`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-white/70 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}